import configuration from "@/utils/Config";
import { restCreationHandler, restGetHandler } from "@/utils/rest/RestClient";
import { createEffect } from "effector";
import { RecapPeriodicityDTO } from "@state/alertPeriodicity/dto/response/recap.periodicity.dto";
import { AlertUserRecapPeriodicityDTO } from "@state/alertPeriodicity/dto/request/alert.user.recap.periodicity.dto";

const baseUrl = configuration.backendBaseUrl;
const alertPeriodicityUrl = baseUrl + "/ws/fo/alert_periodicity";

export const requestGetAlertPeriodicity = createEffect({
  handler: restGetHandler<RecapPeriodicityDTO>(alertPeriodicityUrl),
});

export const requestUpdateAlertPeriodicity = createEffect({
  handler: restCreationHandler<
    AlertUserRecapPeriodicityDTO,
    RecapPeriodicityDTO
  >(alertPeriodicityUrl),
});
